import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <h2 className="about-title">About HandyFixWise</h2>
        <p className="about-text">
          With 5 years of experience, HandyFixWise is your premier choice for professional handyman services across Northridge and the San Fernando Valley. From Reseda and Granada Hills to Porter Ranch, Chatsworth, and surrounding neighborhoods, we deliver reliable, high-quality craftsmanship for all your home repair and improvement needs. Our local experts are dedicated to building long-lasting relationships through trust, transparency, and exceptional work in every neighborhood we serve.
        </p>
      </div>
    </section>
  );
};

export default About;
